import { TrackedChangeType } from 'prose-core'
import { ReactComponent as Trash } from './trash.svg'
import { ReactComponent as Plus } from './plus.svg'
import { ReactComponent as Formatting } from './formatting.svg'
import { LayerChange } from 'providers/LayerChangesProvider/types'

const ICONS = {
  [TrackedChangeType.Insertion]: Plus,
  [TrackedChangeType.Deletion]: Trash,
  [TrackedChangeType.FormattingChange]: Formatting,
  [TrackedChangeType.NodeTypeChange]: Plus,
}

interface Props {
  type: LayerChange['type']
  className?: string
}

export const TrackedChangeIcon = ({ type, className }: Props) => {
  const Icon = ICONS[type]

  return <Icon className={className} />
}
